import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getDetail = createAsyncThunk(
  'detail/getDetail',
  async (id) => {
    const detail = await instanceAPI.get(`get-auction-detail/${id}`)
      .then((resp) => resp.data);
    return detail;
  },
);

const detailSlice = createSlice({
  name: 'detail',
  initialState: {
    detail: [],
    status: null,
    statusNotification: null,
  },
  reducers: {
    notifyMe: (state) => {
      state.statusNotification = true;
    },
  },
  extraReducers: {
    [getDetail.pending]: (state) => {
      state.status = 'loading';
    },
    [getDetail.fulfilled]: (state, action) => {
      state.status = 'success';
      state.detail = action.payload;
    },
    [getDetail.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export const { notifyMe } = detailSlice.actions;
export default detailSlice.reducer;
